import styled from "styled-components";
import Box from "@material-ui/core/Box";
import Drawer from "@material-ui/core/Drawer";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Button } from "../../App.styles";

export const ConsoleDrawer = styled(Drawer)(() => `
    > .MuiPaper-root {
        overflow: visible;
    }
`)

export const ConsoleTabsList = styled(Tabs)(() => `
    && {
        min-height: 0;
    }
`)

export const ConsoleTab = styled(Tab)(() => `
    && {
        min-width: 0;
        min-height: 0;
        text-transform: none;
        font-weight: 400;
    }
`)

export const ConsoleLoggerContainer = styled.div(() => `
    background-color: #242424;
    height: 200px;
    overflow: auto;
    padding: 24px 0;

    [data-method="websocket"] * {
        white-space: nowrap;
        width: auto;
    }

    &.maximized {
        height: 100vh;
    }
`)

export const ConsoleActions = styled.div(() => `
    position: absolute;
    top: 0;
    right: 0;
    height: 36px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 8px;
    z-index: 2;

    > svg {
        cursor: pointer;
    }
`)

export const PullerContainer = styled(Box)(() => `
    position: absolute;
    top: 0;
    visibility: visible;
    right: 0;
    left: 0;
`);

export const Puller = styled(Box)(({ theme }) => `
    color: ${theme.white};
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 12px;
`);

export const ConsoleClear = styled(Button)`
    margin: 0 12px 8px;
    font-size: .75rem;
    border-width: 1px;
    opacity: .75;
`